/* Smileful Jackpot Rain
 * Dauerhafter Geld-/Geschenkregen, nur auf der Jackpot-Seite.
 * Reines Vanilla JS, kein Framework, blockiert nichts.
 */
(function () {
  'use strict';

  console.log('Smileful Jackpot Rain loaded');

  function isJackpotPage() {
    var p = (window.location && window.location.pathname) || '';
    return p.indexOf('/pages/jackpot') !== -1 || p.indexOf('/jackpot') !== -1;
  }

  if (!isJackpotPage()) return;

  function init() {
    if (window.__smfJackpotRainMounted) return;
    window.__smfJackpotRainMounted = true;

    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      console.log('Smileful Jackpot Rain skipped (reduced motion)');
      return;
    }

    /* ---------- CSS injizieren ---------- */
    var STYLE_ID = 'smf-jackpot-rain-style';
    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = [
        '#smf-jackpot-rain{',
        '  position:fixed;inset:0;overflow:hidden;',
        '  pointer-events:none;z-index:2147483647;',
        '  contain:strict;',
        '}',
        '.smf-jackpot-rain__piece{',
        '  position:absolute;top:-10%;line-height:1;opacity:0;',
        '  will-change:transform,opacity;user-select:none;',
        '  filter:drop-shadow(0 4px 10px rgba(59,31,107,.18));',
        '  animation-name:smfJackpotRainFall;',
        '  animation-timing-function:cubic-bezier(.33,.05,.55,.99);',
        '  animation-fill-mode:forwards;',
        '}',
        '@keyframes smfJackpotRainFall{',
        '  0%  {transform:translate3d(0,-10vh,0) rotate(var(--smf-r0,0deg));opacity:0;}',
        '  10% {opacity:var(--smf-op,.7);}',
        '  88% {opacity:var(--smf-op,.7);}',
        '  100%{transform:translate3d(var(--smf-dx,0),110vh,0) rotate(var(--smf-r1,180deg));opacity:0;}',
        '}',
        '@media (prefers-reduced-motion: reduce){#smf-jackpot-rain{display:none!important;}}'
      ].join('');
      document.head.appendChild(style);
    }

    /* ---------- Overlay-Container ---------- */
    var overlay = document.createElement('div');
    overlay.id = 'smf-jackpot-rain';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    console.log('Smileful Jackpot Rain mounted');

    /* ---------- Spawning ---------- */
    var emojis = ['💸', '🎁', '✨', '💜'];
    var weights = [4, 4, 5, 2];
    var weightSum = weights.reduce(function (a, b) { return a + b; }, 0);
    function pickEmoji() {
      var r = Math.random() * weightSum;
      for (var i = 0; i < weights.length; i++) {
        if (r < weights[i]) return emojis[i];
        r -= weights[i];
      }
      return emojis[0];
    }

    var mqMobile = window.matchMedia
      ? window.matchMedia('(max-width: 640px)')
      : null;
    function isMobile() {
      return mqMobile ? mqMobile.matches : window.innerWidth < 640;
    }
    function targetMax() { return isMobile() ? 17 : 30; }

    var alive = 0;
    var paused = false;

    function spawnOne() {
      var e = document.createElement('span');
      e.className = 'smf-jackpot-rain__piece';
      e.textContent = pickEmoji();

      var size  = 20 + Math.random() * 18;          // 20–38 px (gut sichtbar)
      var dur   = 6500 + Math.random() * 4500;      // 6.5–11s
      var delay = Math.random() * 150;
      var leftPct = Math.random() * 100;
      var dxVw  = (Math.random() * 16) - 8;         // -8 bis +8 vw drift
      var rot0  = Math.floor(Math.random() * 60 - 30);
      var rot1  = rot0 + (Math.random() < 0.5 ? -1 : 1) * (90 + Math.random() * 200);
      var op    = 0.55 + Math.random() * 0.30;      // 0.55–0.85 (deutlich sichtbar)

      e.style.left = leftPct + '%';
      e.style.fontSize = size.toFixed(1) + 'px';
      e.style.animationDuration = dur + 'ms';
      e.style.animationDelay = delay + 'ms';
      e.style.setProperty('--smf-dx', dxVw.toFixed(2) + 'vw');
      e.style.setProperty('--smf-r0', rot0 + 'deg');
      e.style.setProperty('--smf-r1', rot1 + 'deg');
      e.style.setProperty('--smf-op', op.toFixed(2));

      alive++;
      var removed = false;
      function cleanup() {
        if (removed) return;
        removed = true;
        if (e.parentNode) e.parentNode.removeChild(e);
        alive = Math.max(0, alive - 1);
      }
      e.addEventListener('animationend', cleanup);
      window.setTimeout(cleanup, dur + delay + 600);

      overlay.appendChild(e);
    }

    /* Initial-Burst: sofort sichtbar */
    var burst = Math.min(targetMax(), isMobile() ? 12 : 20);
    for (var i = 0; i < burst; i++) {
      window.setTimeout(spawnOne, i * 90 + Math.random() * 120);
    }

    /* Slot-Auffüllung */
    function tick() {
      if (paused || document.hidden) return;
      var max = targetMax();
      if (alive < max) {
        var deficit = max - alive;
        var spawnNow = Math.min(3, deficit);
        for (var k = 0; k < spawnNow; k++) {
          window.setTimeout(spawnOne, Math.random() * 350);
        }
      }
    }
    var tickIv = window.setInterval(tick, 480);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });

    window.SmilefulJackpotRain = {
      pause:  function () { paused = true; },
      resume: function () { paused = false; tick(); },
      stop:   function () {
        paused = true;
        window.clearInterval(tickIv);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        window.__smfJackpotRainMounted = false;
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
